import React from "react";

import * as Driver from "~/Driver";
import { Order } from "~/Order";

export function Status(datum: Driver.Table.Datum) {
  return (
    <Driver.Table.Clickable onClick={Driver.Table.useLogLink(datum).go}>
      {datum.status && <Driver.Status.Component status={datum.status} />}
    </Driver.Table.Clickable>
  );
}

export namespace Status {
  export const column = () => ({
    ...Settings.basics(),
    ...Settings.sorting(),
    ...Settings.rendering(),
  });

  namespace Settings {
    export const basics = () => ({
      title: "Status",
      dataIndex: "status",
    });

    export const sorting = () => ({
      defaultSortOrder: "descend",
      sorter: (a: Driver.Table.Datum, b: Driver.Table.Datum) =>
        Order.optionally(Driver.Status.compare)(a.status, b.status),
    });

    export const rendering = () => ({
      render: (_: unknown, datum: Driver.Table.Datum) => <Status {...datum} />,
    });
  }
}
